import axios from 'axios';
import store from '../../store/index';

export default {
	list() {
		return axios.get('/api/tenants?deleted=true', {
			headers: {
				Authorization: `Bearer ${store.state.auth.token}`,
			},
		});
	},
};
